/**
 * CE QUI S'ANNONCE — et qui ne disparaît pas tout seul.
 *
 * « Un toast qui disparaît avant d'avoir été lu — dans un jeu où l'on meurt définitivement, une
 * information manquée est une mort » (design §1). Donc : pas de minuterie. Le message reste jusqu'à
 * ce que le joueur le renvoie, ou jusqu'à ce que l'écran change.
 *
 * `role="alert"` pour ce qui bloque, `role="status"` pour ce qui informe : en mains libres (§7), la
 * différence décide si la phrase interrompt la lecture ou attend son tour.
 */
import type { ReactNode } from "react";
import { t } from "../lexique/langue.js";

interface Props {
  espece: "refus" | "annonce";
  children: ReactNode;
  surFermeture?: () => void;
}

export function Message({ espece, children, surFermeture }: Props) {
  return (
    <div className={`message message--${espece}`} role={espece === "refus" ? "alert" : "status"}>
      <span className="message__texte">{children}</span>
      {surFermeture ? (
        <button type="button" className="bouton bouton--discret" onClick={surFermeture} aria-label={t("Renvoyer ce message")}>
          {t("×")}
        </button>
      ) : null}
    </div>
  );
}
